module.exports = __webpack_public_path__ + "img/banner2.705e5b6d.png";